import { useState, useEffect } from 'react';
import styled from '@emotion/styled';

import { BasicFlex, InputLabel } from '../../../utils/Common';

import { Formik, Form, useFormikContext } from 'formik';

import Field from '../../../utils/FormikFields/Field';
import AutoCompleteSolo from '../../../utils/FormikFields/AutoCompleteSolo';

import MediaZone from '../../Schedule/Components/MediaZone';

import { Button, Grid, IconButton } from '@mui/material';

import EditRoundedIcon from '@mui/icons-material/EditRounded';

import Dialog from '../../../utils/utilities/Dialog';

import { useDialogForm } from '../../../contexts/DialogForm';

import { getRepairs, findSpecialistsByRepair, getAllRepairCategories, getAllRepairsByVendors, getRepairByName } from '../../Repairs/apiService';

import { useQuery } from '@tanstack/react-query';


import { FormDataContext, useFormData } from '../../../contexts/FormData';

import { displayLabelRepair } from '../../../utils/displayLabels';

import { equalIfNotNull } from '../../../utils/util';

const StyledForm = styled(Form)`
  margin: 0 1.5rem;
`;

const EditTaskForm = ({ isSuccess, reset }) => {

  const { handleClose } = useDialogForm() || {};

  const { values, setFieldValue, isSubmitting } = useFormikContext() || {};
  const { formValues, setFormValues } = useFormData() || {};

  let in_house = values?.in_house || false;

  let repair_id = values?.repair_id || null;

  const { data: specialists } = useQuery({
    queryKey: ['specialists', repair_id, in_house],
    queryFn: () => findSpecialistsByRepair(repair_id, in_house),
    enabled: !!repair_id
  })

  const { data: curRepair } = useQuery({
    queryKey: ['repair', values?.repair_name, in_house],
    queryFn: () => getRepairByName(values?.repair_name, in_house),
    enabled: !!values?.repair_name,
    refetchOnMount: "always"
  })

  useEffect(() => {
    if (curRepair) {
      setTimeout(() => {
      setFieldValue("repair_id", curRepair?.repair_id);
      }, 0);
    }
  }, [curRepair]);

  useEffect(() => {
    if (formValues?.in_house === undefined) return;
    setFieldValue("in_house", formValues?.in_house);
  }, [formValues?.in_house])

  useEffect(() => {
    if (formValues?.repair_name !== values?.repair_name || !equalIfNotNull(formValues?.vendor_name, values?.vendor_name) || !equalIfNotNull(formValues?.specialist_name, values?.specialist_name)) {
      setFieldValue("price", formValues?.price);
    }
  }, [formValues?.price, formValues?.repair_name, formValues?.vendor_name, formValues?.specialist_name]);

  useEffect(() => {
    if (isSuccess) {
      if (handleClose) handleClose();
      reset(); // clear mutation state
    }
  }, [isSuccess])

  return (
    <Grid container spacing={3}>
      <Grid size={{xs: 12}}>
        <AutoCompleteSolo
          name = "repair_id"
          url = "repairs"
          fieldName = "repair_id"
          formUpdates = {[{name: `repair_name`, field: "name"}, {name: "in_house", field: "in_house"}]}
          initialValue = {{repair_id: curRepair?.repair_id, name: curRepair?.name, in_house: curRepair?.in_house}}
          displayField={"name"}
          displayLabel={displayLabelRepair}
        />
      </Grid>
      <Grid size={{xs: 6}}>
        <InputLabel>Select Specialist</InputLabel>
            {in_house ? <AutoCompleteSolo
            name = "specialist_id"
            url = "specialists"
            fieldName = "specialist_id"
            serverOptions={specialists}
            formUpdates = {[{name: `specialist_name`, field: "full_name"}, {name: "price", field: "price"}, {name: "duration_in_minutes", field: "duration_in_minutes"}, {name: "estimated_time_to_complete", field: "estimated_time_to_complete"}, {name: "cost", field: "cost"}]}
            displayField={"full_name"}
            /> : <AutoCompleteSolo
            name = "vendor_id"
            url = "vendors"
            fieldName = "vendor_id"
            serverOptions={specialists}
            formUpdates = {[{name: "vendor_name", field: "full_name"}, {name: "price", field: "price"}, {name: "estimated_time_to_complete", field: "estimated_time_to_complete"}, {name: "cost", field: "cost"}]}
            displayField={"full_name"}
            />}
      </Grid>
      <Grid size={{xs: 6}}>
        <Field
          name="price"
          label="Price"
          fullWidth
        />
      </Grid>

      <Grid size={{xs: 12}}>
        <MediaZone />
      </Grid>

      <Grid size={{xs: 12}}>
        <Field
          name="details"
          label="Details"
          multiline
          rows={4}
          fullWidth
        />
      </Grid>
      <Grid size={{xs: 12}} sx={{display: "flex", justifyContent: "flex-end"}}>
        <Button variant="contained" type="submit" loading={isSubmitting}>Update Repair</Button>
      </Grid>
    </Grid>
  )
}

const EditTask = ({ task, saveFunc, isSuccess, reset }) => {

  const [formValues, setFormValues] = useState({

  });

  let initialValues = {...task};

  const handleClose = () => {
    setFormValues({})
  }
  
  return (
    <FormDataContext.Provider value={{ formValues, setFormValues }}>
      <Dialog
        title="Edit Repair Task"
        toggle={<IconButton size="small"><EditRoundedIcon color="secondary" /></IconButton>}
        size="lg"
        saveText="Update Repair"
        useForm={true}
        forceClose={handleClose}
      >
        <Formik
          initialValues={initialValues}
          enableReinitialize
          onSubmit={saveFunc}
        >
          {({ values, errors }) => (
            <StyledForm>
              <EditTaskForm isSuccess={isSuccess} reset={reset} />
            </StyledForm>
          )}
        </Formik>
      </Dialog>
    </FormDataContext.Provider>
  )
}

export default EditTask;